import React from 'react';

export const SystemContext = React.createContext();
export const HomeRouteContext = React.createContext();
export const TranslationsContext = React.createContext();
